import { render, staticRenderFns } from "./GameCreation.vue?vue&type=template&id=fc3992ea&scoped=true"
import script from "./GameCreation.vue?vue&type=script&lang=js"
export * from "./GameCreation.vue?vue&type=script&lang=js"
import style0 from "./GameCreation.vue?vue&type=style&index=0&id=fc3992ea&prod&lang=scss&scoped=true"
import style1 from "./GameCreation.vue?vue&type=style&index=1&id=fc3992ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc3992ea",
  null
  
)

export default component.exports